import { all, takeLatest } from 'redux-saga/effects';
import { Types as AuthTypes } from '../reducers/auth'
import { handleLogin, logout } from './auth'
export default function* root(dispatch) {
  yield all([
    takeLatest(AuthTypes.LOG_IN,handleLogin),
    takeLatest(AuthTypes.SIGN_OUT,logout)
  ])
} 